export default __webpack_public_path__ + "static/favicon-99b4f5a7312a83fef1bd98969cd9c6be.ico";